// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"bb53e782","455":"b997c752","977":"7064de41"}[chunkId] + ".chunk.js";
};